/**
 * Local avatar illustrations.
 *
 * Bundled with the app rather than fetched from an avatar service, so a site
 * office on a bad connection is not waiting on a third party to draw a face,
 * and so nothing about the workforce leaves the deployment.
 *
 * Illustrations, not photographs — see public/avatars/LICENSE.txt for why, and
 * for the CC BY attribution they carry.
 *
 * A real uploaded photo always wins: `avatar_url` from the API is passed to
 * <Avatar src> and takes precedence over anything here.
 */

/** Keep in step with AvatarController::LIBRARY_SIZE. */
export const LIBRARY_SIZE = 30;

const COUNT = LIBRARY_SIZE;

/** The path for one library face, 1-based to match the filenames. */
export function libraryAvatar(index: number): string {
  return `/avatars/av-${String(index).padStart(2, '0')}.svg`;
}

/**
 * The same person gets the same face everywhere, without storing a choice.
 *
 * Hashed from the name for the same reason the initials colour is: two screens
 * showing one worker must not disagree about what they look like.
 */
export function avatarFor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }

  const index = (hash % COUNT) + 1;

  return `/avatars/av-${String(index).padStart(2, '0')}.svg`;
}
